{
  "ribbon": "نموذج تجريبي مكان نموذج الدفع من Dodo Payments في وضع العرض. لا يوجد دفع حقيقي.",
  "notFound": "جلسة الدفع غير موجودة. ارجع وابدأ الدفع من جديد.",
  "email": "البريد الإلكتروني",
  "method": "طريقة الدفع التجريبية",
  "methods": {
    "visa": "Visa تنجح دائمًا",
    "mastercard": "Mastercard تنجح دائمًا",
    "amex": "American Express تنجح دائمًا",
    "paypal": "حساب PayPal ينجح دائمًا",
    "apple_pay": "Apple Pay تنجح دائمًا",
    "visa_declines": "Visa يرفضها البنك دائمًا"
  },
  "declined": "رفض البنك البطاقة ولم يُخصم أي مبلغ. اختر طريقة أخرى وحاول مرة أخرى.",
  "pay": "ادفع",
  "save": "احفظ طريقة الدفع"
}
